<template>
    <section class="mb-10">
        <div class="max-w-6xl mx-auto px-4 pb-0">
            <h2 class="section-header mb-5">{{checkoutTranslate[language].user.membershipSettings}}</h2>
            <div>
                <Notification
                    type="success"
                    :title="checkoutTranslate[language].subscription.change.title(language , success, changeSubscription )"
                    :content="( selected.subscriptionType == 'Team' ? checkoutTranslate[language].subscription.change.subtitle : '' ) "
                    v-if="success"
                /> 
                <Notification
                    type="error"
                    title="Error"
                    :content="error"
                    v-if="error"
                /> 
                  <Notification
                    type="warning"
                    title="Warning"
                    v-if="companionsDataType.type == 'WARNING'"
                    :content="checkoutTranslate[language].companions[companionsDataType.code]"
                /> 
            </div>
            <div class="pt-2 w-full">
                 <div v-if="loading"> 
                    <img class="mx-auto"  src="@/assets/img/app-loader.gif" width="150" alt="">
                </div>
                <div class="relative" v-else>
                    
                <div class="border-b mb-5 xs:pb-5" v-if="subscription">
                    <h4 class="mb-1" :class="{'disabled' : companionsDataType.type != 'SUCCESS'  }">    {{dashboardTranslate[language].subscription.settings.change}} </h4>
                    <p class="text-gray-800 text-sm" :class="{'disabled' : companionsDataType.type != 'SUCCESS' }">{{checkoutTranslate[language].user.membershipChoose}}</p>
                    <div class="flex flex-col md:flex-row justify-start items-left" :class="{'disabled' : companionsDataType.type != 'SUCCESS' }">
                        <div v-for="plan in plans" :key="plan.code">
                        <div class="form-radio-wrapper md:pr-10" v-if="plan.type != 'downgrade' && plan?.subscriptionTier.toUpperCase() != 'MAX'">
                            <input 
                                class="form-check-radio mr-2 border-green-400 radioType" type="radio" name="membresia"
                                v-model="type"
                                :id="`m_individual-${plan.code}`"
                                :data="plan.code"
                                ref="typeRadio"
                                :value="plan.code"
                                @click="typeCode = plan.code"
                            >
                            <label class="form-check-label text-gray-800" :for="`m_individual-${plan.code}`">
                                {{plan.name}}
                            </label>
                        </div>
                        </div>
                    </div>
                </div> 
                    <div  v-if="subscription" >
                        <div class="border-b pb-5 mb-5 " :class="{ 'disabled' : companionsDataType.type != 'SUCCESS' ||  selected.subscriptionType.toLowerCase() != 'team' }">
                            <h4 class="mb-1">{{checkoutTranslate[language].user.membershipCompanions}}</h4>
                            <p class="text-gray-800 mb-5 text-sm" v-if="addOns">{{ checkoutTranslate[language].user.companionsEdit( subscription.subscription.companionsNumber + addOnCount , ( addOns.newMaxQuantity - addOnCount) )}}</p>
                            <div class="flex md:flex-row sm:flex-col  xs:flex-col justify-start items-start ">
                                <div class="p-0  md:pr-10 lg:w-1/4 sm:w-full xs:w-full">
                                    <h5 class="block">{{checkoutTranslate[language].user.numberCompanions}}</h5>
                                    <div class="flex flex-row w-full justify-between mt-2 mb-2">
                                        <button @click="onChange('sub')" class="rounded-full bg-blue-100 text-white w-12 h-12 flex justify-center items-center content-center" 
                                        :class="{'disabled' : addOnCount == 0 || companionsData.currentQuantity == addOnCount + 1 }"
                                        :disabled='selected.subscriptionType.toLowerCase() == "single"  &&  addOnCount == 0 || companionsData.currentQuantity == addOnCount + 1'>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z" clip-rule="evenodd" />
                                            </svg>
                                        </button>

                                        <div class="relative flex content-center items-center w-12 py-2 text-2xl text-green-500 font-bold justify-center">
                                            {{ addOnCount }}
                                        </div>

                                        <button @click="onChange('add')" class="rounded-full bg-blue-100 text-white w-12 h-12 flex justify-center items-center content-center" 
                                        :class="{'disabled' : addOns.newMaxQuantity  == addOnCount}" :disabled='selected.subscriptionType.toLowerCase() == "single"'>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div class="flex flex-row items-start justify-between md:items-end w-1/2 sm:w-full sm:mt-5 xs:mt-5 xs:w-full xs:items-center md:w-1/2 align-start">
                                    <div class="flex flex-col items-end md:items-end w-auto md:w-full xs:items-center align-top">
                                        <h5>{{checkoutTranslate[language].user.membership}}</h5>
                                        <div class="flex flex-row content-start">
                                            <h3 class="text-3xl md:text-2xl font-bold text-green-500">{{ addOns.netAmount }}</h3>
                                            <span class="text-sm md:text-xs text-green-500 mt-1 mx-1">$</span>
                                        </div>
                                        <h5 class="-mt-1">{{currency}} /
                                            <span v-if="selected.paymentTerm == 'Annual' ">
                                                {{checkoutTranslate[language].payment.yearly}}
                                            </span>
                                            <span v-else>
                                                {{checkoutTranslate[language].payment.month}}
                                            </span>
                                        </h5>
                                    </div>
                                    <div class="flex flex-col items-end md:items-end w-1/2 md:w-full xs:items-center align-top ">
                                        <h5>{{checkoutTranslate[language].user.extraCompanion}}</h5>
                                        <div class="flex flex-row content-start">
                                            <h3 class="text-3xl md:text-2xl font-bold text-green-500">{{ parseFloat(addOnPrice).toFixed(0) }}</h3>
                                            <span class="text-sm md:text-xs text-green-500 mt-1 mx-1">$</span>
                                        </div>
                                        <h5 class="-mt-1">{{currency}} / <span v-if="selected.paymentTerm == 'Annual' ">
                                                {{checkoutTranslate[language].payment.yearly}}
                                            </span>
                                            <span v-else>
                                                {{checkoutTranslate[language].payment.month}}
                                            </span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex items-center justify-between sm:flex-col md:flex-row lg:flex-row xs:flex-col ">
                        <div class="w-6/12 sm:w-full xs:w-full" >
                            <div  v-if="selected.annualPrice">
                                <p class="text-xs text-gray-800" v-show="selected.subscriptionType.toLowerCase() == 'team'" v-if="selected.annualPrice.planAmount">
                                    {{ checkoutTranslate[language].user.increaseCompanionsTeam( ( parseFloat(addOnPrice)  ) + Math.round( selected.annualPrice.planAmount * parseFloat('1.'+selected.taxPercentage)  / 10) * 10 , currency) }}
                                    
                                </p>
                            </div>
                            <p class="text-xs text-gray-800" v-if="selected.subscriptionType.toLowerCase() == 'single'">
                            </p>
                        </div>
                        <div class="flex sm:w-full xs:mt-5 xs:w-full sm:justify-center sm:py-5 md:py-0">
                            <router-link :to="{ name : 'DashboardSubscription' }" tag="button" class="xs:w-full  text-black py-4 px-10 font-semibold border-b-4 mx-4" > {{checkoutTranslate[language].button.cancel}} </router-link>
                            <button :class="{'bg-blue-50 disabled' : companionsDataType.type == 'WARNING' }" class="rounded-xl text-white py-4 px-10 font-semibold bg-blue-100 xs:w-full" @click="onChangePlan"> {{checkoutTranslate[language].button.change}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { useStore } from "vuex"
import { computed, ref } from "@vue/reactivity"
import {  useRouter } from "vue-router"
import { onMounted, watch } from "@vue/runtime-core"
import { checkoutTranslate } from '@/translations/Checkout.js'
import { dataLayerMembershipCheckout, dataLayerViewChangeNotification  } from  '@/pixels/datalayer.js'
import { dashboardTranslate } from '@/translations/Dashboard.js'
import Notification from "@/components/notifications/Notification.vue"

export default({
    name: 'TipoDeMembresia',
    components:{
        Notification
    },
    setup() {
        /* eslint-disable*/
       
        const store = useStore()
        const router = useRouter()
        const typeRadio = ref(null)
        const type = ref('')
    
        const addOnCount = ref(0)
        const coupon = ref('')
        const currency = computed(() => {
            return  localStorage.getItem('viva-currency') ? localStorage.getItem('viva-currency') : 'MXN';
        })
        const referral = ref('')
        const addOnPrice = ref(0)
        const total = ref({ totalAmount:0, totalTermAmount: 0 })
       
        const validation  = ref({
            month : null,
            number : null,
            year: null,
            first_name : null,
            last_name : null
        })
        const showModalProcessing = ref(false)
        const showModalValidation = ref(false)
        const loading = computed(() => {
            return store.state.Plans.loading 
        })
        /*
        * Initialize computed data
        */

        const changeSubscription = computed(() => {
            return store.state.Checkout.upgrade.subscription
        })

        const error = computed(() => {
            return store.state.Checkout.error.doupgrade
        })

        const success = computed(() => {
            return store.state.Checkout.success.doupgrade
        })

        const plans = computed( () => {
            return store.state.Plans.data.plans 
        })

        const language = computed( ()=> {
            return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
        })
        

        const addOns = ref({});
        const setAddOns =  ( preload ) =>{
             let addons = {
                    newMaxQuantity: 0,
                    netAmount: 0,
                    defaultQuantity: 0
                }
            if( plans.value ){
                const plan = preload ? plans.value.find( ({subscriptionType }) => { return subscriptionType == 'Team' }) :  plans.value.find( ({code }) => { return code == typeCode.value  })
                if( plan ){
                     if( plan.addOns ){
                        addons = plan.addOns[0]
                        addons.newMaxQuantity =   addons.defaultQuantity == subscription.value.subscription.companionsNumber  ? 0  :  addons.maxQuantity - subscription.value.subscription.companionsNumber + 1
                    }
                }
            }
            addOns.value =  addons
            addOnPrice.value =(addOnCount.value * addOns.value.netAmount).toFixed(2)

        
        }

        const companionsData =  computed(() => {
            return store.state.Checkout.data.userCompanions.data ? store.state.Checkout.data.userCompanions : { currentQuantity : 0 }
        })

        const selected = computed( () => {
            return store.getters.getSelectedPlan
        })

        const subscription = computed(() => {
            return store.state.Checkout.data.userSubscription.data
        })
        const paymentType =  computed ( () => {
           const data = store.getters.getSelectedPlan
           return data.code ? { monthly : data.code , annual : ( data.variants ? data.variants[0] : '' )   } : { monthly : null , annual : null  }
        })

         const companionsDataType = computed( () => {
            
            return  subscription.value ? subscription.value.subscription.subscriptionType == 'Single' ? { type: 'SUCCESS'} : store.state.Checkout.status.userCompanions : {} 
        }) 
        const paymentTypeCode = ref(paymentType.value.monthly)
        /*
        * Initialize Function
        */
        const expireDate  = () =>{
    
            const expire = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            const lang = language.value  == 'es' ? 'es-ES' : 'en-US'

            return expire.toLocaleDateString(lang, options)
        }

        const onChange = ( type ) => {
            const max = addOns.value.newMaxQuantity      
           if( type == 'add' ){
                addOnCount.value = addOnCount.value < max ? ++addOnCount.value : max 
            } if( type == 'sub' ) {
                addOnCount.value = companionsData.value.currentQuantity == addOnCount.value + 1 ? addOnCount.value  :  addOnCount.value < max ? --addOnCount.value : addOnCount.value <= 0 ? 0 : --addOnCount.value
                addOnCount.value = addOnCount.value <= 0 ? 0 : addOnCount.value
            }
            addOnPrice.value = (addOnCount.value * addOns.value.netAmount).toFixed(2)

            const t = parseFloat(selected.value.totalAmount) + parseFloat(addOnPrice.value)
            
            total.value.totalAmount =  (t).toFixed(2)
        }
        const onSelectSelectedPackage = () => {

            if( plans.value ){
                 const plan = plans.value.find( ({subscriptionType}) =>  subscriptionType == subscription.value.subscription.subscriptionType )
                store.commit( 'SELECT_PLAN', {...selected.value, ...plan} )
            }
           
        }
        const checkSelected = () => {

            if( subscription.value ){
            if ( Object.keys( subscription.value.subscription.subscriptionType ).length == 0 ) {
                router.push({ name : 'Home' }) 
            } else{
             
                if ( subscription.value.subscription.subscriptionType.toLowerCase() == 'team'){
                    addOnCount.value = 0
                    addOnPrice.value = ( addOnCount.value * addOns.value.netAmount).toFixed(2)
                } 
                    total.value = { totalAmount :  selected.value.totalPagar, totalTermAmount :  selected.value.totalPagarTerm }
                    paymentTypeCode.value = subscription.value.subscription.code
                }
            }
        }

          const onSelectPlan = async ( plan ) => {
            const found = plans.value.find( ({code}) => code  == typeCode.value  )
            const variants =  store.state.Checkout.data.variants
            if ( plan == 'single' ){
                addOnPrice.value = addOnCount.value = 0
            }

            if( plan == 'team' ){
                if( subscription.value.subscription.companionsNumber === 0 ) {
                    store.state.Checkout.data.userSubscription.data.subscription.companionsNumber = 1 
                    addOnPrice.value = 0
                }
            } 
            
            setAddOns()

            if ( found ){
                store.commit( 'SELECT_PLAN', found )
                total.value = { totalAmount :  selected.value.totalAmount, totalTermAmount :  selected.value.totalTermAmount }
                paymentTypeCode.value = selected.value.code

                if( !variants ){
                   await store.dispatch('getVariantsData' , { variant : selected.value.code , currency : currency.value } )
                    getAnnualPrice()
                } else {
                    const find =  variants.find(({variant}) => variant == selected.value.code )
                    if( !find ){
                        await store.dispatch('getVariantsData' , { variant : selected.value.code , currency : currency.value },  )
                         getAnnualPrice()
                    }
                }
               
            }
        }

        const getAnnualPrice = () =>{
            const variants =  store.state.Checkout.data.variants
            const find =  variants.plans.find(({variant}) => variant == selected.value.code )
            const look = find.plans.find(({paymentTerm}) => paymentTerm.toLowerCase() == 'annual' )
            const lessDiscount = look.planAmount - look.discount
            const taxDecimal = ( look.taxPercentage / 100 )
            const taxAmount = lessDiscount * taxDecimal
            const tax = look.taxAmount ? look.taxAmount : taxAmount

            store.state.Plans.selected.annualPrice = {
                planAmount : look.planAmount,
                taxAmount : tax,
                totalAmount: look.totalPagar,
                netTotalAmount: look.netTotalAmount,
                netTotalTermAmount: look.netTotalTermAmount,
            }
        } 
    
        const onCloseValidation = () =>{
            showModalValidation.value = false
            validation.value = {}
        }


        const setDatalayer = () =>{
            dataLayerMembershipCheckout( selected.value )
        }

        const getPlans = async () => {
            const currencyParameter = ( currency.value == 'MXN' ? `?currency=${currency.value}` : `?currency=${currency.value}`)
            await store.dispatch('getPlans', { currency: currencyParameter, useAuthToken : true, plan: `&plan=${subscription.value.subscription.code}`}) 
        }

        const onChangePlan = async ( ) => {
            let params 
            if( selected.value.subscriptionType ){
                if( selected.value.subscriptionType.toLowerCase() == 'single' ){
                    params =  { planCode : selected.value.code }
                if(  selected.value.coupon ) {
                    params.couponCode = selected.value.coupon.code
                }
                }
                if( selected.value.subscriptionType.toLowerCase() == 'team' ){
                    params =  { planCode : selected.value.code ,
                                companionsQuantity : addOnCount.value + subscription.value.subscription.companionsNumber 
                    }
                    if(  selected.value.coupon ) {
                        params.couponCode = selected.value.coupon.code
                    }
                }
                await store.dispatch('onChangePlan', params )


            }
            await onCheckSubscription()
            if( success.value  ){
                dataLayerViewChangeNotification( { type : 'success', paymentTerm : subscription.value.subscription.paymentTerm })
            }
             if( error.value  ){
                dataLayerViewChangeNotification( { type : 'unsuccessful', paymentTerm : subscription.value.subscription.paymentTerm })
            }
        }

        const onCheckSubscription = async () =>{
             if( !subscription.value ){
                let params = { plan: 'vfn' , continue : false} 
                if( Object.keys(store.state.Accounts.data).length == 0 ){
                    params.continue  = true
                }
                await store.dispatch('getSubscription', params )

            }
        }
        const typeCode = ref(null)
        /*`
        * Watcher Functions
        */
        watch( type, ( value )  => {
            onSelectPlan( value )
        })
        /*
        * Mounted Functions
        */    
       
        onMounted( async () => {
          
                await onCheckSubscription()
                await onSelectSelectedPackage()
                await checkSelected()
                await setDatalayer()
                await store.dispatch('callCompanionsAvailable', { subscriptionId : subscription.value.subscription.id })

            
            if( !plans.value ){
                await getPlans()    
            }

            if( Object.keys(store.state.Accounts.data).length == 0 ){
                await store.dispatch('checkAccount')
            }
                setAddOns( true)
        })
        

        return {
            companionsDataType,
            selected,
            plans,
            type,
            paymentType,
            paymentTypeCode,
            subscription,
            addOns,
            addOnPrice,
            addOnCount,
            total,
            validation,
            onChange,
            expireDate,
            typeRadio,
            showModalValidation,
            showModalProcessing,
            onCloseValidation,
            checkoutTranslate,
            companionsData,
            language,
            currency,
            onChangePlan,
            error,
            typeCode,
            success,
            loading,
            dashboardTranslate,
            changeSubscription
            
        }
    },
    data() {
        return {
            isPage: 'resumen',
            country: "MX",
        }
    },
})
</script>

<style scoped>
.section-header {
	@apply text-3xl text-green-400 font-semibold;
}
.box {
    @apply bg-white border border-gray-200 shadow rounded-lg text-left overflow-hidden;
}
h4 {
    @apply text-lg md:text-lg text-green-500 font-bold;
}
h5 {
    @apply md:text-sm text-green-500;
    font-size: 0.75rem;
}
input.form-control, select.form-control{
    @apply font-semibold text-left focus:ring-green-400 focus:border-green-400 block w-full text-18 border-gray-300 pt-7 pb-2 px-4 rounded-xl shadow-sm border text-green-500 outline-none;
}
label > span {
    @apply text-green-500 sm:text-xs;
}
.form-check-radio {
    @apply w-5 h-5 border-2 rounded-full bg-blue-100;
}
.form-radio-wrapper {
    @apply flex content-center items-center pt-5 pb-0 md:py-5 w-full md:w-auto;
}
.disabled {
    @apply opacity-50 cursor-not-allowed
}
</style>